import { render } from "./ProductPriceSolarInfoCard.vue?vue&type=template&id=6d8ab0eb"
import script from "./ProductPriceSolarInfoCard.vue?vue&type=script&lang=js"
export * from "./ProductPriceSolarInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__